export default "__VITE_ASSET__BCC8_A6h__"